import type { AgendaSettings } from "@bookdental/schemas";
import { Field, Toggle, settingsInputCls } from "./primitives";

type Props = {
  values: AgendaSettings;
  onChange: (partial: Partial<AgendaSettings>) => void;
};

export function RemindersSection({ values, onChange }: Props) {
  return (
    <div className="space-y-6">
      <Toggle
        label="Ativar lembrete automático por padrão"
        description="Novas consultas já vêm com lembrete WhatsApp ligado"
        checked={values.whatsappReminderDefault}
        onChange={(v) => onChange({ whatsappReminderDefault: v })}
      />

      <Field label="Quando enviar o lembrete">
        <select
          className={settingsInputCls}
          value={values.reminderTime}
          onChange={(e) =>
            onChange({ reminderTime: e.target.value as AgendaSettings["reminderTime"] })
          }
        >
          <option value="1h">1 hora antes</option>
          <option value="12h">12 horas antes</option>
          <option value="24h">24 horas antes</option>
          <option value="48h">48 horas antes</option>
        </select>
      </Field>

      <Field
        label="Template da mensagem"
        hint="Placeholders disponíveis: {nome}, {data}, {hora}, {procedimento}, {clinica}"
      >
        <textarea
          className={`${settingsInputCls} h-auto resize-none py-2`}
          rows={4}
          value={values.reminderTemplate}
          onChange={(e) => onChange({ reminderTemplate: e.target.value })}
        />
      </Field>
    </div>
  );
}
